module.exports = __webpack_public_path__ + "static/media/login-logo.18151b58.png";